import { DashboardOutlined } from '@ant-design/icons';

const dashboard = {
  id: 'dashboard-overview',
  title: 'Dashboard',
  type: 'item',
  url: '/dashboard',
  icon: DashboardOutlined
};

export default dashboard;
